/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Valid_FromInputs */

const en_reference_field_valid_from = /** @type {(inputs: Reference_Field_Valid_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid from`)
};

/**
* | output |
* | --- |
* | "Valid from" |
*
* @param {Reference_Field_Valid_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_valid_from = /** @type {((inputs?: Reference_Field_Valid_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Valid_FromInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_valid_from(inputs)
});